import { Component, ComponentInterface, Element, h, Host, JSX, Prop } from '@stencil/core';
import { SpinnerTheme } from './spinner-theme';
import { SpinnerSize } from './spinner-size';
import { getDataOnFromTheme, WorkbenchTheme } from '../../shared/themes';

/**
 * Spinners are used as a sign that something is loading or being processed on a page.
 */
@Component({
  tag: 'wb-spinner',
  styleUrl: 'spinner.scss',
  shadow: true,
})
export class SpinnerComponent implements ComponentInterface {
  @Element()
  public el: HTMLElement;

  /**
   * Defines spinner appearance to match background color
   * @deprecated Use `data-on` and `data-on-brand` attributes instead
   * */
  @Prop({ reflect: true })
  public theme: SpinnerTheme;

  /** Spinner size */
  @Prop({ reflect: true })
  public size: SpinnerSize;

  /** If present, stops the spinning animation */
  @Prop({ reflect: true })
  public paused: boolean = false;

  public render(): JSX.Element {
    return (
      <Host aria-live="polite" aria-busy="true" class="wb-spinner" data-on={getDataOnFromTheme(this.el, this.theme as WorkbenchTheme)} data-on-brand={this.theme === 'blue' && !this.el.hasAttribute('data-on-brand')}>
        <div class="inner" />
      </Host>
    );
  }
}
